import { useLocation, useParams } from "react-router";
import React, { useState, useEffect, useHistory } from "react";

import axios from "axios";
import jwt_decode from "jwt-decode";
import "../modal.css";

import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Spinner";
import { Button } from "react-bootstrap";
import jsPDF from "jspdf";
import "jspdf-autotable";

const Withdrawals = () => {
  const location = useLocation();
  let [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);

  const param = useParams();
  const getTransactions = async () => {
    let response;

    response = await axios
      .get("withdrawals/" + param.id, {})
      .then((res) => {
        setTransactions(res.data);
        setLoading(false);
        // notify()
      })
      .catch((err) => {
        setLoading(false);
        notifyError();
      });
  };

  const notify = () =>
    toast.success("withdrawals loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  useEffect(() => {
    getTransactions();
  }, [location.key]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Withdrawals",
        columns: [
          {
            Header: "Id",
            accessor: "id",
          },
          {
            Header: "Amount",
            accessor: "amount",
          },
          {
            Header: "Date",
            accessor: "createdAt",
          },
        ],
      },
    ],
    []
  );

  return (
    <div>
      <div className="col-13">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Driver withdrawal from pocket</h3>
          </div>

          <div className="card-body">
            {loading && (
              <div>
                <Spinner />
              </div>
            )}
            {!loading && <Table columns={columns} data={transactions} />}
          </div>
        </div>
      </div>

      {/* 
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">List of Transactions</h3>
                </div>

                <div className="card-body">
                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}
                  {!loading && <Table columns={columns} data={transactions} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Withdrawals;
